import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const createAuthEvent = (type) => {
  const event = new CustomEvent('authStateChange', { detail: { type } });
  document.dispatchEvent(event);
};

const auth = {
  login: (token, user) => {
    Cookies.set("token", token, { secure: true, sameSite: "strict" });
    Cookies.set("user", JSON.stringify(user), { secure: true, sameSite: "strict" });
    createAuthEvent('login');
  },

  logout: (callback) => {
    Cookies.remove("token");
    Cookies.remove("user");
    createAuthEvent('logout');
    if (callback) callback();
  },

  getToken: () => {
    return Cookies.get("token");
  },

  getUser: () => {
    try {
      const user = Cookies.get("user");
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },

  getUserId: () => {
    const user = auth.getUser();
    return user?.id || null;
  },

  getUserRole: () => {
    const user = auth.getUser();
    return user?.role || null;
  },

  isAuthenticated: () => {
    const token = auth.getToken();
    if (!token) return false;

    try {
      const { exp } = jwtDecode(token);
      if (Date.now() >= exp * 1000) {
        return false;
      }
      return true;
    } catch {
      return false;
    }
  },

  isAuthorized: (role) => {
    const userRole = auth.getUserRole();
    return userRole === role;
  },
};

export default auth;